import OverlayBase from "../overlay/OverlayBase";
import React, {useState} from "react";
import SvgLoader from "../../../svg/SvgLoader";

export interface ConfirmOverlayData {
    title: string,
    text?: string,
    confirmText?: string,
    cancelText?: string,
    onConfirm: () => Promise<string|undefined>,
}

export default function ConfirmOverlay(props: { data: ConfirmOverlayData, hide: () => void }){

    const [loading, setLoading] = useState<boolean>(false)

    const [error, setError] = useState<string>("")

    const handleDisable = async () => {
        if (loading){
            return
        }

        setError("")
        setLoading(true)

        const error = await props.data.onConfirm()

        setLoading(false)

        if (error){
            setError(error)
        }
        else{
            props.hide()
        }
    };

    return (
        <OverlayBase hide={props.hide} w="w-[28rem]">
            <h2 className="text-xl font-semibold mb-4">{props.data.title}</h2>
            {props.data.text && <div className="space-y-4">{props.data.text}</div>}
            <div className="mt-6 flex flex-col items-end">
                {error && <p className="text-red-500 text-sm mb-2 text-right">{error}</p>}
                <div className="flex justify-end gap-3">
                    <button onClick={props.hide}
                            className="px-4 py-2 hover:bg-neutral-700 border border-neutral-500 rounded-lg">{props.data.cancelText ?? "Cancel"}
                    </button>
                    <button onClick={handleDisable} disabled={loading}
                            className="px-4 py-2 bg-primary text-black hover:bg-primary-hover rounded-lg disabled:bg-neutral-600 flex items-center">
                        {loading ? <SvgLoader className="size-5 text-transparent fill-white text-neutral-700 animate-spin inline" /> : props.data.confirmText ?? "OK"}
                    </button>
                </div>
            </div>
        </OverlayBase>
    )
}